var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('div',{staticClass:"embed-responsive"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"loading":"lazy","sandbox":"allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation","allowfullscreen":"","src":_vm.url}})]):_c('div',[_c('p',[_vm._v("Video not found.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }